// extracted by mini-css-extract-plugin
module.exports = {"input":"Input_input_2_TK6","icon":"Input_icon_2A7zM"};